import { format, parseISO } from 'date-fns';
import { reportToSentry } from './sentry';

export const formatDate = (
  dateString: string,
  dateFormat = 'MMM d',
): string | null => {
  try {
    const date = parseISO(dateString);
    return format(date, dateFormat);
  } catch (error) {
    reportToSentry(error);
    return null;
  }
};
